var render = function render(_c,_vm){return _c('div',{class:_vm.props.value === 0 ? 'is-danger' : ''},[_vm._v(_vm._s(_vm.props.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }